namespace $ {
	
	$mol_dom_context = window as any
	
}
